import { Component, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { CellRendererService } from 'src/app/common/ag-grid-table/cell-renderers/dynamic.cell-renderer';
import { LinkCellRendererComponent } from 'src/app/common/ag-grid-table/cell-renderers/render-components/link/link.component';
import { getDefaultTableColumns } from 'src/app/common/ag-grid-table/default-table-columns';
import { AgGridToolsService } from 'src/app/common/ag-grid-table/services/ag-grid-tools.service';
import { UtilitiesService } from 'src/app/common/services/utilities.service';

@Component({
  selector: 'app-qa-users-ag-grid',
  templateUrl: './qa-users-ag-grid.component.html',
  styleUrls: ['./qa-users-ag-grid.component.sass']
})
export class QAUsersAgGridComponent implements OnInit {

  public entity: string = 'qa-users';
  public columnDefs: ColDef[] = [];
  public bulkUpdateColDefs: any[] = [];
  public columnSelection: string;
  public autopopulateSelect: string = '';
  public buildParams: any = {};
  public tableParams: any = {};


  constructor(
    private cellRendererService: CellRendererService,
    private agGridToolsService: AgGridToolsService,
  ) { }

  async ngOnInit(): Promise<void> {

    const defaultColumns = getDefaultTableColumns(this.entity, this.agGridToolsService);

    this.columnDefs = [
      ...defaultColumns,
      {
        headerName: 'Identifier',
        field: 'identifier',
        cellRendererParams: {
          entity: this.entity
        },
        cellRenderer: LinkCellRendererComponent,
        width: 250,
        sortable: true,
        unSortIcon: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,

        cellEditor: 'agTextCellEditor',
        type: 'editableColumn',
      },

    ]

    this.bulkUpdateColDefs = [
      {
        name: 'Identifier', id: 'identifier', type: 'text'
      },
      {
        name: 'Internal Identifier', id: 'internalIdentifier', type: 'text'
      },
    ];

    this.tableParams = {
      customActionsLabel: 'Custom Bulk Actions',
      customActionButtons: ['bulkLocalize'],
      localizeCollectionName: 'qa-users',
    }

    this.columnSelection = this.agGridToolsService.getColumnFieldNamesFromCols(this.columnDefs);
  }

}
